import React, {FC} from 'react';

import {RoleManager} from '@touchnet/user-management';

import useRoleManagerConfig from '~/hooks/use-role-manager-config';
import RoleDetailsProvider from "~/components/pages/user-mgmt/providers/role-details-provider";

export const UserMgmtRolesPage: FC = () => {
    const {roles} = useRoleManagerConfig();
    return (<RoleManager roles={roles}  DetailsProvider={RoleDetailsProvider}/>);
};

export default UserMgmtRolesPage;
